'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { CurrencyDisplay } from '@flipster/features/src/misc/display';
import { authBunja } from '@flipster/features/src/shared/auth/state';
import { useRouter } from '@flipster/i18n/routing';
import { useOverlay } from '@flipster/overlay';
import { IconButton } from '@flipster/react/design-system/icon-button';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { hstack } from '@flipster/styled-system/patterns';
import { PusdtCurrency, UsdtCurrency } from '@flipster/utils/constants/currency';

import PusdtNudgeModal from '@web/app/[locale]/(web)/_modal/premium-earn/pusdt-nudge-modal';

export const CurrencyHeader = ({ currency }: { currency: string }) => {
  const overlay = useOverlay();
  const router = useRouter();
  const { isLoggedInAtom } = useBunja(authBunja);
  const isLoggedIn = useAtomValue(isLoggedInAtom);

  return (
    <div className={hstack({ justify: 'space-between', color: 'content.default.level-4' })}>
      {currency === PusdtCurrency ? (
        <CurrencyDisplay
          currency={currency}
          icon={<CurrencyDisplay.Icon size={32} space={16} />}
          mainLabel={
            <div className={hstack()}>
              <CurrencyDisplay.Label value='fullName' />
              <IconButton
                icon={<ChevronRightIcon />}
                size='small'
                hierarchy='quaternary'
                onClick={() => {
                  if (isLoggedIn) {
                    overlay.open(<PusdtNudgeModal />);
                  } else {
                    router.push('/login');
                  }
                }}
              />
            </div>
          }
          subLabel={UsdtCurrency}
          css={{ textStyle: 'Text/L/Strong' }}
        />
      ) : (
        <CurrencyDisplay
          currency={currency}
          icon={<CurrencyDisplay.Icon size={32} space={16} />}
          mainLabel={<CurrencyDisplay.Label value='shortName' />}
          css={{ textStyle: 'Text/L/Strong' }}
        />
      )}
    </div>
  );
};
